module.exports = __webpack_public_path__ + "static/img/gywm_zzry_img_bg.4aac5b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gywm_zzry_img_bg.png
// module id = XIsn
// module chunks = 21